import Grid from "@mui/material/Grid2";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import SelectBoxSearch from "../../../../shared/components/select_box_search";
import { formatDate } from "../../../../shared/util/functions";
import { gerenciaTecnicaSlice, selectGtoState, selectMainState, useDispatch } from "../../../../stateManagement/redux";
import { getReportsList } from "../../../../stateManagement/redux/slices/gerencia_tecnica/asyncReducers";
import { ReportInterface } from "../../../../stateManagement/redux/slices/gerencia_tecnica/interfaces";
import { formatDateToYYYYMMDD } from "src/shared/util/formatDates";
import { RoutesWeb } from "src/shared/interfaces/routes";
import { Box, FormControl, InputAdornment, InputLabel, MenuItem, Select, TextField } from "@mui/material";
import DatePicker from "react-datepicker";
import { ProjectList } from "src/stateManagement/redux/slices/shared/interfaces";
import moment from "moment";
import "./styles.scss";
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';


const Dashboards = () => {
    const navigate = useNavigate();
    const options: string[] = ["Nombre", "Codigo"];

    const dispatch = useDispatch();

    const { configModules } = useSelector(selectMainState);

    const [selectedOption, setSelectedOption] = useState(options[0]);

    // const [activeReport, setActiveReport] = useState<ReportInterface>();

    const [inputValueFilter, setInputValueFilter] = useState<string>("");

    const [listOfReports, setListOfReports] = useState<ReportInterface[]>([]);

    const mainState = useSelector(selectGtoState);

    const [projectList, setprojectList] = useState<ProjectList[]>([])

    const [startDate, setStartDate] = useState(new Date());
    const [endDate, setEndDate] = useState(new Date());

    const [projectId, setProjectId] = useState("");

    const onClickSetActiveReport = (report: ReportInterface) => {
        dispatch(gerenciaTecnicaSlice.actions.setReportFilter({ startDate: formatDateToYYYYMMDD(startDate), endDate: formatDateToYYYYMMDD(endDate), projectId, activeReport: report }));

        console.log("report", report);
        if (report.name === "Consolidado Campo BCP") {
            navigate(RoutesWeb.gerencia_tecnica_operaciones.reports_consolidate_bcp);
        }else if (report.name === "Consolidado Campo BM") {
            navigate(RoutesWeb.gerencia_tecnica_operaciones.reports_consolidate_bm);
        }else if (report.name === "Cartas BM") {
            navigate(RoutesWeb.gerencia_tecnica_operaciones.reports_consolidate_cards_bm);
        }else if (report.name === "Cierre Día") {
            navigate(RoutesWeb.gerencia_tecnica_operaciones.reports_close_daily);
        }else if (report.name === "Resumen Diario Tierra") {
            navigate(RoutesWeb.gerencia_tecnica_operaciones.reports_daily_summary);
        }else if (report.name === "Relacion de Analisis y Requerimientos") {
            navigate(RoutesWeb.gerencia_tecnica_operaciones.analyst_summary);
        }else if (report.name === "Reporte Vehicular") {
            navigate(RoutesWeb.gerencia_tecnica_operaciones.reports_overview);
        
        }else if (report.name === "Chequeo Físico") {
            navigate(RoutesWeb.gerencia_tecnica_operaciones.reports_physical_check);
        } else {
            navigate(
                RoutesWeb.gerencia_tecnica_operaciones.reports_consolidate_bcp
            );
        }
    };

    useEffect(() => {
        if (configModules?.projectList){
            setprojectList(configModules?.projectList);
        }

    }, [configModules])
    

    useEffect(() => {
        if (mainState?.reportsList?.length === 0) {
            dispatch(getReportsList());
        }
    }, []);

    useEffect(() => {
        let reports = mainState.reportsList;

        if (!Array.isArray(reports) || reports.length === 0) return;

        reports = reports?.map((report) => {
            return {
                id: report.id,
                code: report.code,
                name: report.name,
                description: report.description,
                department: report.department,
                version: report.version,
                config: report.config,
                updated: report.releaseDate
                    ? formatDate(report.releaseDate, "dd-MMM-yyyy")
                    : "pendiente",
                type: report.type,
            };
        });

        if (inputValueFilter === "") {
            setListOfReports(reports);
        } else if (selectedOption === "Nombre") {
            setListOfReports(
                reports.filter((report) =>
                    report.name
                        .toLowerCase()
                        .includes(inputValueFilter.toLowerCase())
                )
            );
        } else if (selectedOption === "Codigo") {
            setListOfReports(
                reports.filter((report) =>
                    report.code
                        .toLowerCase()
                        .includes(inputValueFilter.toLowerCase())
                )
            );
        }
    }, [inputValueFilter, mainState.reportsList]);

    const handleSelectChange = (
        event: React.ChangeEvent<HTMLSelectElement>
    ) => {
        setSelectedOption(event.target.value);
        setInputValueFilter("");
    };

    const handleFilterInput = (event: React.ChangeEvent<HTMLInputElement>) => {
        setInputValueFilter(event.target.value);
    };

    const onCloseReport = () => {
        // setActiveReport(undefined);
        dispatch(gerenciaTecnicaSlice.actions.emptyReportData());
    }

    return (
        <>
            <Grid container spacing={2}>
                <Grid
                    size={12}
                    className="dashboard_container_filter_container"
                >
                    <Grid
                        size={4}
                        sx={{
                            display: "flex",
                        }}
                    >
                        <Box
                            sx={{
                                boxShadow: "none",
                                height: "40px",
                                width: "220px",
                                backgroundColor: "custom.blue2",
                                borderTopLeftRadius: "10px",
                                borderBottomLeftRadius: "10px",
                                color: "#FFF",
                                display: "flex",
                                alignItems: "center", 
                                justifyContent: "center", 
                                fontWeight: "bold", 
                                fontSize: "16px", 
                            }}
                        >
                            Fecha Inicio
                        </Box>
                        <DatePicker
                            selected={startDate}
                            onChange={(date: Date | null) =>
                                setStartDate(date || new Date())
                            }
                            showTimeSelect={false}
                            dateFormat="dd-MM-yyyy"
                            placeholderText="DD-MM-YYYY"
                            customInput={
                                <TextField
                                    fullWidth
                                    variant="outlined"
                                    size="small"
                                    InputProps={{
                                        endAdornment: (
                                            <InputAdornment position="end">
                                                <CalendarTodayIcon />
                                            </InputAdornment>
                                        ),
                                    }}
                                    sx={{
                                        backgroundColor: "white",
                                        borderTopLeftRadius: 0,
                                        borderBottomLeftRadius: 0,
                                        "& .MuiOutlinedInput-root": {
                                            borderTopLeftRadius: 0,
                                            borderBottomLeftRadius: 0,
                                        },
                                    }}
                                />
                            }
                            popperClassName="consolidate_files_container_custom_input_date_picker"
                        />
                    </Grid>
                    <Grid
                        size={4}
                        sx={{
                            display: "flex",
                        }}
                    >
                        <Box
                            sx={{
                                boxShadow: "none",
                                height: "40px",
                                width: "220px",
                                backgroundColor: "custom.blue2",
                                borderTopLeftRadius: "10px",
                                borderBottomLeftRadius: "10px",
                                color: "#FFF",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                fontWeight: "bold",
                                fontSize: "16px",
                            }}
                        >
                            Fecha Fin
                        </Box>
                        <DatePicker
                            selected={endDate}
                            onChange={(date: Date | null) =>
                                setEndDate(date || new Date())
                            }
                            showTimeSelect={false}
                            dateFormat="dd-MM-yyyy"
                            placeholderText="DD-MM-YYYY"
                            customInput={
                                <TextField
                                    fullWidth
                                    variant="outlined"
                                    size="small"
                                    sx={{
                                        backgroundColor: "white",
                                        borderTopLeftRadius: 0,
                                        borderBottomLeftRadius: 0,
                                        "& .MuiOutlinedInput-root": {
                                            borderTopLeftRadius: 0,
                                            borderBottomLeftRadius: 0,
                                        },
                                    }}
                                    InputProps={{
                                        endAdornment: (
                                            <InputAdornment position="end">
                                                <CalendarTodayIcon />
                                            </InputAdornment>
                                        ),
                                    }}
                                />
                            }
                            popperClassName="consolidate_files_container_custom_input_date_picker"
                        />
                    </Grid>
                    <Grid
                        size={4}
                        sx={{
                            display: "flex",
                        }}
                    >
                        <Box
                            sx={{
                                boxShadow: "none",
                                height: "40px",
                                width: "220px",
                                backgroundColor: "custom.blue2",
                                borderTopLeftRadius: "10px",
                                borderBottomLeftRadius: "10px",
                                color: "#FFF",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                fontWeight: "bold",
                                fontSize: "16px",
                            }}
                        >
                            Proyectos
                        </Box>
                        <FormControl
                            fullWidth
                            sx={{
                                backgroundColor: "white",
                                borderTopLeftRadius: 0,
                                borderBottomLeftRadius: 0,
                                "& .MuiOutlinedInput-root": {
                                    borderTopLeftRadius: 0,
                                    borderBottomLeftRadius: 0,
                                },
                            }}
                        >
                            <Select
                                size="small"
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                value={projectId}
                                onChange={(e) => setProjectId(e.target.value)}
                                displayEmpty
                                renderValue={(selected) => {
                                    if (!selected)
                                        return "Selecciona una opción";
                                    const proyecto = projectList.find(
                                        (p) => p.projectId === selected
                                    );
                                    return proyecto?.name || selected;
                                }}
                            >
                                <MenuItem value="" disabled>
                                    Selecciona una opción
                                </MenuItem>

                                {projectList.map((f, index) => (
                                    <MenuItem key={index} value={f.projectId}>
                                        {f.name}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>
                </Grid>
                <Grid size={6} sx={{ mt: 2 }}>
                    <SelectBoxSearch
                        options={options}
                        selectedOption={selectedOption}
                        onOptionChangeSelectBox={handleSelectChange}
                        onValueChangeInput={handleFilterInput}
                        inputValue={inputValueFilter}
                    />
                </Grid>
                <Grid size={12} className="table_reports_dashboards">
                    <div className="header">
                        <div
                            className="header__title"
                            style={{
                                marginLeft: "10px",
                            }}
                        >
                            Código
                        </div>
                        <div className="header__title">Nombre</div>
                        <div className="header__title">Descripción</div>
                        <div className="header__title">Departamento</div>
                        <div className="header__title">Versión</div>
                        <div className="header__title">Actualización</div>
                    </div>
                    <div className="_body_row">
                        {listOfReports.map((report, index) => (
                            <div
                                key={index}
                                className="body_row"
                                onClick={() => onClickSetActiveReport(report)}
                            >
                                <div>{report.code}</div>
                                <div>{report.name}</div>
                                <div>{report.description}</div>
                                <div>{report.department}</div>
                                <div>{report.version}</div>
                                <div>{report.updated}</div>
                            </div>
                        ))}
                    </div>
                </Grid>
            </Grid>
        </>
    );
};

export default Dashboards;